import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { loginUser } from "../../actions/auth.js";
import logo from '../../images/dsas/logo.svg';
import {TextField, Box, Typography, Grid} from '@mui/material'

import "../../styles/global.css"
import DsasButton from "../../v1/components/DsasButton/DsasButton.js";
import { ERROR_CLEAR_AUTHENTICATION } from "../../constants/actionTypes.js";

export default function Login() {

    const dispatch = useDispatch()

    const navigate = useNavigate();

    const authentification = useSelector((state) => state.authentication)

    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
      navigate('/lives')
    }, [])
  
    const handleSubmit = async e => {
      e.preventDefault();
      dispatch({ type: ERROR_CLEAR_AUTHENTICATION });
      dispatch(loginUser({user : username, password}))
    }

      return (
        <Box className='centered-wrapper login-page-background'>

        
           <Grid container sx={{alignItems : 'center'}}>
              <Grid item xs={0.5} sm={2} md={3} lg={4}>
              </Grid>
              <Grid item xs={11} sm={8} md={6} lg={4}>
                <Box className='login-page-wrapper'>
        
        <Box className=''>
  
        {/*LOGO SECTION*/}
        <Box className='centered-wrapper column-wrapper medium-padding'>
          <Box className='fit-content-wrapper display-grid'>
            <img className='logo-xl' src={logo} alt="Logo"/>
            <p className='subtitle-alt'>Direct</p>
          </Box>
        </Box>

        <Box className='medium-padding'></Box>
        <Box className='large-separator'></Box>

        {/*LOGIN FORM SECTION*/}
        <Box className='centered-wrapper column-wrapper'>
          {/*TITLE*/}
          <Box className='medium-padding'>
            <Typography variant='h1' fontWeight='bold' className='page-title' sx={{paddingTop:'1rem'}}>Se connecter</Typography>
          </Box>
   
          <form className="full-width">
            {/*FORM*/}
            <Box className={'medium-padding'}>
            <Grid container sx={{alignItems : 'center'}}>
              <Grid item xs>
                <Box className='medium-padding column-wrapper' sx={{paddingLeft:'2rem', paddingRight:'2rem'}} >
                  <Typography className='dark-label'>Identifiant</Typography>
                  <TextField
                    name="username" 
                    variant="outlined"
                    fullWidth 
                    value={username}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                  </Box>
                <Box className='centered-medium-wrapper column-wrapper' sx={{paddingLeft:'2rem', paddingRight:'2rem'}}>
                  <Typography className='dark-label'>Mot de passe</Typography>
                  <TextField
                    name="password" 
                    variant="outlined"
                    type="password"
                    fullWidth 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Box>
                </Grid>
              </Grid>

              {authentification.error && <Box className='centered-wrapper' >
                <Typography className='error-label' sx={{paddingLeft:'2rem', paddingRight:'2rem'}}>{authentification.error}</Typography>
              </Box>}

              </Box>
              

              <Box className='medium-padding'></Box>
              <Box className='large-separator'></Box>
              <Box className='medium-padding'></Box>

              {/*SUBMIT*/}
              <Grid container sx={{alignItems : 'center'}}>
                <Grid item xs >
                  <Box className='centered-wrapper medium-padding' >
                    <DsasButton onClick={handleSubmit} type="button" label="CONNECTER" variant = 'alternative' customCss={{padding:'0.2rem', width:'13rem' }} />
                  </Box>

                </Grid>
              </Grid>

              <Box className='medium-padding'></Box>

            </form>
            

          </Box>
          </Box>
          </Box>

        </Grid>
        <Grid item xs={0.5} sm={2} md={3} lg={4}></Grid>
      </Grid>
</Box>
      );
  }